import { Pipe, PipeTransform } from '@angular/core';
import { UserModel } from 'models/generated/Identity.Api.Models.User';
import { UserService } from 'services/user.service';

@Pipe({
	name: 'user'
})
export class UserPipe implements PipeTransform {

	constructor(private readonly userService: UserService) { }

	transform(user?: UserModel | string, format?: 'name' | 'initials' | 'email'): string {

		if (typeof user === 'string') user = this.userService.user(user) ?? undefined;
		if (!user) return '';

		switch (format) {
			case 'name':
				return user.name;
			case 'initials':
				return this.userService.getUserInitials(user);
			case 'email':
				return user.email
		}

		throw new Error('Invalid parameters for UserPipe');
	}
}
